<template>
  <div class="form-group has-label">
    <label v-if="label" :for="id" class="control-label">{{ label }}</label>
    <el-select :class="selectClass"
               :id="id"
               :remote-method="loadChoices"
               :placeholder="placeholder"
               :value="value"
               @change="change"
               filterable
               :loading="loading"
               reserve-keyword
               remote>
      <el-option
        v-for="choice in choices"
        :key="choice[choiceValue]"
        :label="choice[choiceLabelKey]"
        :value="choice[choiceValue]">
      </el-option>
    </el-select>
  </div>
</template>

<script>
  import uuid from 'uuid/v4'
  import {Select, Option} from 'element-ui'

  export default {
    name: 'RemoteSelect',
    components: {
      [Select.name]: Select,
      [Option.name]: Option
    },
    props: {
      id: {
        type: String,
        default: () => uuid()
      },
      apiUrl: !String,
      value: ![Number, String, Object],
      label: {
        type: String,
        default: () => null
      },
      placeholder: {
        type: String,
        default: () => null
      },
      choiceValue: {
        type: String,
        default: () => 'id'
      },
      choiceLabelKey: {
        type: String,
        default: () => 'name'
      },
      selectClass: {
        type: String,
        default: () => 'select-success'
      },
      limit: {
        type: Number,
        default: () => null
      }
    },
    data () {
      return {
        choices: [],
        loading: false
      }
    },
    created () {
      this.loadChoices()
    },
    mounted () {
      this.loadChoices()
    },
    methods: {
      async loadChoices (query) {
        if (!this.loading) {
          this.loading = true
          const params = {}
          if (query) {
            params.search = query
          }
          if (this.limit) {
            params.limit = this.limit
          }
          try {
            const response = await this.axios.get(this.apiUrl, {params})
            this.loading = false
            const data = response.data
            if (data instanceof Array) {
              this.choices = data
            } else if (data.results) {
              this.choices = data.results
            } else {
              console.error(`Неизвестный ответ от сервера`, data)
            }
          } catch (e) {
            console.error(`Не удалось загрузить варианты`, e)
            this.loading = false
          }
        }
      },
      change(value) {
        this.$emit('input', value)
      }
    }
  }
</script>

<style scoped>

</style>
